import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { handleDelete } from "../../utils/Alerts";
import { getMedia } from "../services/providerService";
import { category as staticCategory } from "../constant/learningManagment";
import { Link, useNavigate } from "react-router-dom";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import eyeimg from "../../images/eye.svg";
import Loader from "../../utils/Loader";
import "./MediaManagment.css";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";

function MediaListing() {
  const userdata = useSelector((state) => state);
  let adminRole = userdata?.login?.data?.role;
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    _getMediaList();
  }, [page, limit]);

  const _getMediaList = (
    searchText,
    sortby,
    mediaType,
    category1 = category
  ) => {
    setLoading(true);
    getMedia(
      {
        page: page + 1,
        limit,
        searchKey: searchText,
        sortBy: sortby,
        mediaType: mediaType,
        category: category1,
      },
      (data) => {
        setMediaList(data?.list || []);
        setTotalPages(data?.totalPages || 0);
        setTotalItems(data?.totalItems || 0);
        setLoading(false);
      },
      dispatch
    );
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getMediaList(query, selectedSortValue);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const redirectToProfile = (provider) => {
    navigate("/admin/provider/profile", { state: { provider: provider?._id } });
  };

  const EditMedia = (media) => {
    navigate(`/admin/media-management/add-media`, {
      state: { media: media },
    });
  };

  const ViewMedia = (media) => {
    navigate(`/admin/media-management/view-media`, {
      state: { media: media },
    });
  };

  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [selectedMediaTypeValue, setSelectedMediaTypeValue] = useState("");

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey); // Update the state with the selected value
    _getMediaList(searchText, eventKey, selectedMediaTypeValue);
  };

  const handleSuccess = (data) => {
    // Refresh the list or perform other actions after deletion
    _getMediaList();
  };

  const handleCategorySelect = (category) => {
    setCategory(category);
    setTotalPages(0);
    setTotalItems(0);
    setPage(0);
    _getMediaList(searchText, selectedSortValue, "", category);
  };

  const getDataBack = () => {};

  return (
    <div className="Dashboard-wrapper">
      {loading && <Loader />}

      <div className="add-doctor">
        <Form>
          <Form.Group controlId="searchInput">
            <Form.Control
              type="search"
              aria-label="Search"
              value={searchText}
              onChange={handleSearchChange}
              placeholder="Search media by title..."
            />
          </Form.Group>
        </Form>

        <Button
          onClick={() => navigate("/admin/media-management/add-media")}
          className="filled-btn"
        >
          Create
        </Button>

        <Dropdown className="patient-info-dropdown " onSelect={handleSelect}>
          <Dropdown.Toggle className="db-dropdown h-100 ">
            {selectedSortValue === ""
              ? "Sort By"
              : selectedSortValue === "name-asc"
              ? "Name A-Z"
              : "Name Z-A"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Default</Dropdown.Item>
            <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
            <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          className="patient-info-dropdown"
          onSelect={handleCategorySelect}
        >
          <Dropdown.Toggle className="db-dropdown h-100 ">
            {category === "" ? "Category" : category}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="All">All</Dropdown.Item>
            {staticCategory?.map((category, index) => (
              <Dropdown.Item eventKey={category}>{category}</Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="table-responsive dashboard-table">
        <table className="patients-table">
          <thead>
            <tr className="t-row-block">
              <th scope="col">Sr No</th>
              <th scope="col">Title</th>
              <th scope="col">Category</th>
              <th scope="col">Sub-Category</th>
              <th scope="col">Actions</th>

              {/* <th scope="col">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {mediaList.length > 0 ? (
              mediaList.map((media, index) => (
                <tr key={media.id || index}>
                  <td scope="row">{++index}</td>
                  <td
                  // onClick={() => redirectToProfile(media)}
                  >
                    <div className="d-flex align-items-center gap-2 ">
                      {media?.title ? media?.title : "-"}{" "}
                    </div>
                  </td>

                  <td>{media?.category ? media?.category : "-"}</td>
                  <td>{media?.category ? media?.subCategory : "-"}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <a
                        className="edit-del-icon eye-edit-del eye-img"
                        onClick={() => {
                          ViewMedia(media);
                        }}
                      >
                        <img src={eyeimg} alt="view" />
                      </a>
                      <a
                        className="edit-del-icon eye-edit-del edit-img"
                        onClick={() => {
                          EditMedia(media);
                        }}
                      >
                        <img src={editicon} alt="edit" />
                      </a>
                      <a
                        className="edit-del-icon eye-edit-del del-img"
                        onClick={() =>
                          handleDelete(
                            `/user-service/media/${media._id}/delete`,
                            handleSuccess,
                            {},
                            getDataBack
                          )
                        }
                      >
                        <img src={binicon} alt="delete" />
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Media Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default MediaListing;
